import store from '../../store'

export function showDocTemplatesModal(docId,addLinkToLinear) {	
	store.dispatch({type:'SHOW_DOC_TEMPLATES_MODAL',docId:docId,addLinkToLinear:addLinkToLinear})
}
